"use client";

// DIRECTIVE #025: price-gate hook for price-displaying components.
// PASTE #246: prices now require the `approved` (or `admin`) group, NOT
// mere sign-in. A signed-in-but-not-approved user (e.g. a fresh
// federated login) sees no prices. Authoritative gate is server-side
// (isApprovedRequest + /api/catalog crypto-verify); this hook is UX only.

import { useIsApproved, type ApprovalState } from "./useIsApproved";

export type PriceGateState =
  | { ready: false }
  | { ready: true; canSeePrices: boolean };

// Returns ready=true with canSeePrices once the approval check resolves.
// During the brief async-hydration window (ready=false), consumers
// render a placeholder span to avoid layout shift + the "Sign in"
// flash for already-approved users.
export function usePriceGate(): PriceGateState {
  const state: ApprovalState = useIsApproved();
  if (state === "loading") return { ready: false };
  return { ready: true, canSeePrices: state === "approved" };
}
